import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './BetaBadge.module.css';

const BetaBadge = ({ className = null }) => {
  return <span className={classNames(css.root, className)}>BETA</span>;
};

BetaBadge.propTypes = {
  className: PropTypes.string,
};

export default BetaBadge;
